import React, { useState, useEffect } from 'react';
import { useFirebaseAuth } from '../services/firebase';
import LayoutOnboarding from '../components/LayoutOnboarding';
import * as Sentry from '@sentry/react';
import { FormInput } from '@/components/forms/FormInput';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FieldError, FieldGroup } from '@/components/ui/field';

const SignIn: React.FC<any> = (props) => {
    const { signIn, signUp, resetPassword } = useFirebaseAuth();
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const [signupMode, setSignupMode] = useState(false);

    const [msg, setMsg] = useState<string>('');

    useEffect(() => {
        setMsg('');
    }, [signupMode]);

    async function doSignIn(e: any) {
        e.preventDefault();
        if (email.length && password.length) {
            const res: any = await signIn(email, password);
            // console.log('signIn res', res);

            if (res.code && res.code === 'auth/user-not-found') {
                setMsg("This user doesn't exist. Check that you entered the correct email or create a new account.");
            } else if (res.code && res.code === 'auth/wrong-password') {
                setMsg('The password you entered is invalid. Please try again.');
            } else if (res.code) {
                setMsg(`An error occured: ${res.code}`);
                Sentry.captureMessage(`Login Error for Email ${email}`);
                Sentry.captureException(res);
            }
        } else {
            setMsg('Please enter a valid email and password.');
        }
    }

    async function doSignUp(e: any) {
        e.preventDefault();
        if (email.length && password.length) {
            const res: any = await signUp(email, password);

            if (res.code && res.code === 'auth/email-already-in-use') {
                setMsg('A user with this email address already exists. Try logging in.');
            } else if (res.code) {
                setMsg('An error occured');
                console.log('Error', res);
            }
        } else {
            setMsg('Please enter a valid email and password.');
        }
    }

    async function doReset(e: any) {
        e.preventDefault();
        if (email.length) {
            const res: any = await resetPassword(email);
            console.log('doReset res', res);

            if (typeof res === 'undefined') {
                setMsg('Check your email for a reset link.');
            } else if (res.code === 'auth/user-not-found') {
                setMsg("This user doesn't exist. Check your email or create a new account.");
            } else {
                setMsg('An error occured');
            }
        } else {
            setMsg('Please enter a valid email.');
        }
    }

    return (
        <>
            <div>
                <LayoutOnboarding>
                    <form className="mx-auto mb-4 w-80 max-w-full" onSubmit={(e) => (signupMode ? doSignUp(e) : doSignIn(e))}>
                        <Card>
                            <CardHeader>
                                <CardTitle>{signupMode ? 'Sign Up' : 'Log In'}</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <FieldGroup>
                                    {msg ? <FieldError>{msg}</FieldError> : null}
                                    <FormInput id="signin-email" label="Email" placeholder="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                    <FormInput id="signin-password" label="Password" placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                    <Button type="submit" className="w-full">
                                        {signupMode ? 'Sign Up' : 'Log In'}
                                    </Button>
                                    {signupMode ? null : (
                                        <Button type="button" variant="link" className="h-auto p-0" onClick={doReset}>
                                            Forgot Password?
                                        </Button>
                                    )}
                                </FieldGroup>
                            </CardContent>
                        </Card>
                    </form>

                    <div>
                        {signupMode ? (
                            <div>
                                Already a member?{' '}
                                <Button type="button" variant="link" className="h-auto p-0" onClick={() => setSignupMode(!signupMode)}>
                                    Log In
                                </Button>
                            </div>
                        ) : (
                            <div>
                                Don't Have an Account?{' '}
                                <Button type="button" variant="link" className="h-auto p-0" onClick={() => setSignupMode(!signupMode)}>
                                    Sign Up
                                </Button>
                            </div>
                        )}
                    </div>
                </LayoutOnboarding>
            </div>
        </>
    );
};

export default SignIn;
